// 插件计费标准：前台「计费标准」Tab 与计费弹窗共用同一份数据，避免两处价格/单位漂移。
export interface PricingItem {
  id: number;
  optType: string;
  price: number;
  unit: string;
  /** 仅展示会员折后价；实际折扣由服务端按会员等级结算。 */
  memberPrices?: { svip: number; vip: number };
}

export const FILE_UPLOAD_PRICE = 0.08;

export const PRICING_ITEMS: PricingItem[] = [
  {
    id: 1,
    optType: '站内文件上传',
    price: FILE_UPLOAD_PRICE,
    unit: '次',
  },
  {
    id: 2,
    optType: '视频编辑插件',
    price: 0.05,
    unit: '次',
  },
  {
    id: 3,
    optType: '邮件发送接口',
    price: 0.05,
    unit: '次',
  },
  {
    id: 4,
    optType: '剪映草稿云渲染',
    price: 0.3,
    unit: '分钟',
    memberPrices: { svip: 0.18, vip: 0.24 },
  },
  {
    id: 5,
    optType: '视频智能分镜',
    price: 0.01,
    unit: '秒',
  },
];

export const PRICING_NOTICE =
  '仅当您使用需 API Key 的接口时会计费，其余所有接口均可免费无限次调用；计费规则可能随时调整，请以实际扣费为准。如有疑问，请联系客服。';
